<ng-template #nonstock let-modal>
	<div class="ns-modal-header">
		<div class="ns-modal-title">
			<mat-icon class="ns-title-icon">add_shopping_cart</mat-icon>
			<span>New Non&#8209;Stock Item</span>
		</div>
		<button type="button" class="ns-close-btn" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="ns-modal-body">
		<form [formGroup]="nonStockForm" *ngIf="nonStockForm">

			<!-- Tires: library search -->
			<ng-container *ngIf="config.env.package === 'tires'">
				<div class="ns-section">
					<span class="ns-eyebrow">Library Search</span>
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Search tire library</mat-label>
						<mat-icon matPrefix class="ns-field-icon">search</mat-icon>
						<input matInput [formControl]="librarysearch">
					</mat-form-field>
					<mat-progress-bar mode="indeterminate" color="accent" *ngIf="librarySearching" class="mb-2"></mat-progress-bar>
				</div>

				<div class="ns-library-results mb-3" *ngIf="librarySearchResults">
					<ul class="list-group">
						<li class="list-group-item cpdata" *ngFor="let option of librarySearchResults" (click)="selectLibraryItem(option)">
							<div class="row align-items-center">
								<div class="col-2" *ngIf="option.model">
									<img [src]="option.model.make.imageUrl" class="img-fluid nonstocklogo" alt="Make Image">
								</div>
								<div class="col-2" *ngIf="option.model">
									<img [src]="option.model.imageUrl" class="img-fluid nonstockimage" *ngIf="option.model.imageUrl" alt="Model Image">
								</div>
								<div class="col-8">
									<strong>{{option.model.make.name}} {{option.model.name}}</strong>
									<span class="text-muted ml-1">{{ option.displayName }}</span>
								</div>
								<ng-container *ngIf="loadingItem">
									<svg class="spinner" width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
										<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
									</svg>
								</ng-container>
							</div>
						</li>
					</ul>
				</div>
			</ng-container>

			<!-- ── IDENTITY SECTION ──────────────────────────────── -->
			<div class="ns-section ns-section--identity">
				<span class="ns-eyebrow">Product Identity</span>

				<div class="ns-identity-tiles">

					<!-- Brand tile -->
					<div class="ns-tile" [class.ns-tile--selected]="nonStockForm.get('brand').value != ''" [class.ns-tile--required]="nonStockForm.get('brand').invalid && nonStockForm.get('brand').touched">
						<ng-container *ngIf="nonStockForm.get('brand').value == ''">
							<div class="ns-tile__placeholder">
								<mat-icon class="ns-tile__icon-empty">local_offer</mat-icon>
								<mat-form-field appearance="standard" class="ns-tile__select">
									<mat-label>Select Brand</mat-label>
									<mat-select formControlName="brand">
										<mat-option *ngFor="let v of brands" [value]="v">{{v.name}}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</ng-container>
						<ng-container *ngIf="nonStockForm.get('brand').value != ''">
							<div class="ns-tile__content">
								<div class="ns-tile__avatar">{{ (nonStockForm.get('brand').value.name || '?').charAt(0).toUpperCase() }}</div>
								<div class="ns-tile__info">
									<span class="ns-tile__sublabel">Brand</span>
									<span class="ns-tile__name">{{ nonStockForm.get('brand').value.name }}</span>
									<span class="ns-tile__sub" *ngIf="nonStockForm.get('brand').value.mfg_code">{{ nonStockForm.get('brand').value.mfg_code }}</span>
								</div>
								<button mat-icon-button class="ns-tile__clear" type="button" (click)="nonStockForm.get('brand').setValue('')">
									<mat-icon>close</mat-icon>
								</button>
							</div>
						</ng-container>
					</div>

					<!-- Vendor tile -->
					<div class="ns-tile" [class.ns-tile--selected]="selectedsupplier">
						<ng-container *ngIf="!selectedsupplier">
							<div class="ns-tile__placeholder">
								<mat-icon class="ns-tile__icon-empty">storefront</mat-icon>
								<app-vendor-lookup (vendor_selected)="selectNonStockVendor($event)" class="ns-vendor-lookup"></app-vendor-lookup>
							</div>
						</ng-container>
						<ng-container *ngIf="selectedsupplier">
							<div class="ns-tile__content">
								<div class="ns-tile__avatar ns-tile__avatar--vendor">{{ (selectedsupplier.suppname || '?').charAt(0).toUpperCase() }}</div>
								<div class="ns-tile__info">
									<span class="ns-tile__sublabel">Vendor</span>
									<span class="ns-tile__name">{{ selectedsupplier.suppname }}</span>
									<span class="ns-tile__sub">{{ selectedsupplier.supplierid }}</span>
								</div>
								<button mat-icon-button class="ns-tile__clear" type="button" (click)="selectedsupplier = false;">
									<mat-icon>close</mat-icon>
								</button>
							</div>
						</ng-container>
					</div>

				<!-- Product Line (compact, spans only if productlines exist) -->
				<div class="ns-tile ns-tile--line" *ngIf="productlines?.length">
					<div class="ns-tile__content ns-tile__content--line">
						<div class="ns-tile__info">
							<span class="ns-tile__sublabel">Product Line</span>
							<select class="ns-line-select" formControlName="productline">
								<option value="">— select —</option>
								<option *ngFor="let v of productlines" [value]="v.line_field">{{v.line_description}}</option>
							</select>
						</div>
					</div>
				</div>

				</div>
			</div>

			<!-- ── DESCRIPTION SECTION ───────────────────────────── -->
			<div class="ns-section">
				<span class="ns-eyebrow">Item Details</span>
				<div class="ns-description-row">
					<mat-form-field appearance="outline" class="ns-field--description">
						<mat-label>Description</mat-label>
						<input matInput required formControlName="description" class="ns-description-input" placeholder="e.g. Deep Conditioner 250ml">
					</mat-form-field>
					<mat-form-field appearance="outline" class="ns-field--part">
						<mat-label>Part #</mat-label>
						<input matInput formControlName="partno" placeholder="Vendor part #">
					</mat-form-field>
					<mat-form-field appearance="outline" class="ns-field--barcode">
						<mat-label>Barcode / SKU</mat-label>
						<mat-icon matPrefix class="ns-field-icon">qr_code_scanner</mat-icon>
						<input matInput formControlName="barcode" placeholder="Scan or type">
					</mat-form-field>
				</div>
			</div>

			<!-- ── PRICING SECTION ───────────────────────────────── -->
			<div class="ns-section ns-section--pricing">
				<span class="ns-eyebrow">Pricing &amp; Quantity</span>
				<div class="ns-pricing-strip">

					<div class="ns-price-block ns-price-block--qty">
						<span class="ns-price-label">Qty</span>
						<div class="ns-price-input-wrap">
							<span class="ns-price-prefix">#</span>
							<input class="ns-price-input ns-price-input--center" matInput required formControlName="qty" type="text" inputmode="numeric">
						</div>
					</div>

					<div class="ns-price-block" [class.d-none]="config.env.package == 'beauty' && !user.user.viewcost">
						<span class="ns-price-label">Cost</span>
						<div class="ns-price-input-wrap">
							<span class="ns-price-prefix">$</span>
							<input class="ns-price-input text-right" formControlName="cost" type="text" inputmode="decimal">
						</div>
					</div>

					<div class="ns-price-block ns-price-block--price">
						<span class="ns-price-label">Sell Price <span class="ns-required-star">*</span></span>
						<div class="ns-price-input-wrap" [class.ns-price-input-wrap--hint]="estprice || matrixdiscount > 0">
							<span class="ns-price-prefix">$</span>
							<input class="ns-price-input text-right" required formControlName="price" type="text" inputmode="decimal">
						</div>
						<span class="ns-price-hint" *ngIf="estprice">Suggested: {{ suggestedMarkup | currency }}</span>
						<span class="ns-price-hint" *ngIf="matrixdiscount > 0">Matrix {{ matrixdiscount }}% applies</span>
					</div>

					<div class="ns-price-block" *ngIf="config.env.package == 'tires'">
						<span class="ns-price-label">FET</span>
						<div class="ns-price-input-wrap">
							<span class="ns-price-prefix">$</span>
							<input class="ns-price-input text-right" formControlName="fet" type="text" inputmode="decimal">
						</div>
					</div>

					<div class="ns-price-block ns-price-block--designation" *ngIf="config.env.package == 'tires'">
						<span class="ns-price-label">Designation</span>
						<select class="ns-price-select" formControlName="designation">
							<option value="">— select —</option>
							<option *ngFor="let v of designations" [value]="v.value">{{v.viewValue}}</option>
						</select>
					</div>

				</div>
			</div>

			<!-- ── FOOTER BAR ─────────────────────────────────────── -->
			<div class="ns-footer-bar">
				<mat-slide-toggle formControlName="taxable" *ngIf="config.env.package == 'beauty'" class="ns-tax-toggle">
					Always Taxable
				</mat-slide-toggle>
				<span *ngIf="config.env.package != 'beauty'"></span>
				<button mat-flat-button class="ns-submit-btn"
					[class.ns-submit-btn--ready]="nonStockForm.valid"
					[class.ns-submit-btn--invalid]="!nonStockForm.valid"
					type="button"
					(click)="addNonStock()">
					<mat-icon>add_circle</mat-icon>
					<span>{{ nonStockForm.valid ? 'Add To Order' : 'Complete Required Fields' }}</span>
				</button>
			</div>

		</form>
	</div>
</ng-template>

<button mat-stroked-button color="primary" (click)="nonStockModal()" *ngIf="config.features.nonstock">
	<mat-icon>add</mat-icon> Add Non Stock
</button>
